import { useMemo } from 'react'
import type { FactoryHookType } from '../type'
import maybeCreateOtherComponentTypeFilterNode from './OtherComponentTypeFilterNodeFactory'

const useOtherComponentTypeFilter: FactoryHookType = ({ RendererComponent, options }) => {
  return useMemo(() => {
    return maybeCreateOtherComponentTypeFilterNode({
      componentType: options.componentType,
      RendererComponent,
    })
  }, [options.componentType, RendererComponent])
}

export default useOtherComponentTypeFilter
